﻿import React from 'react';
import {render} from 'react-dom';
import {Router, Route, IndexRoute, browserHistory} from 'react-router'
import { Provider } from 'react-redux';
import InjectTapEventPlugin from 'react-tap-event-plugin';

import App from './app';
import Login from './components/core/login-page';
import Dashboard from './components/dashboard/dashboard';
import Templates from './components/templates/templates';
import TemplateDetails from './components/templates/template-details';
import TemplatePreview from './components/templates/template-preview';
import TemplateSend from './components/templates/template-send';
import Roles from './components/roles/roles';
import Role from './components/roles/role';
import Members from './components/members/members';
import Member from "./components/members/member";
import ChatArchive from './components/chat-archive/chat-archive';
import FeedSources from './components/feed-sources/feed-sources';
import FeedSource from './components/feed-sources/feed-source';

import store from './stores/redux-store';

import "../../node_modules/ag-grid/dist/styles/ag-grid.css";
import "../../node_modules/ag-grid/dist/styles/theme-material.css";
import "../../Content/main.css";

// Needed for onTouchTap
// http://stackoverflow.com/a/34015469/988941
InjectTapEventPlugin();


function requireAuth(nextState, replace) {
    /*if (!AuthStore.loggedIn()) {
        replace({
            pathname: '/login',
            state: {nextPathname: nextState.location.pathname}
        });
    }*/
}

render(
    <Provider store={store}>
        <Router history={browserHistory}>
            <Route path="/" component={App}>
                <IndexRoute component={Dashboard} onEnter={requireAuth}/>
                <Route path="login" component={Login}/>
                <Route path="dashboard" component={Dashboard} onEnter={requireAuth}/>
                <Route path="templates" component={Templates} onEnter={requireAuth}/>
                <Route path="template/:templateId" component={TemplateDetails} onEnter={requireAuth}/>
                <Route path="template/preview/:templateId" component={TemplatePreview} onEnter={requireAuth}/>
                <Route path="template/send/:templateId" component={TemplateSend} onEnter={requireAuth}/>
                <Route path="roles" component={Roles} onEnter={requireAuth}/>
                <Route path="role/:roleId" component={Role} onEnter={requireAuth}/>
                <Route path="members" component={Members} onEnter={requireAuth}/>
                <Route path="member/:memberId" component={Member} onEnter={requireAuth}/>
                <Route path="chat-archive" component={ChatArchive} onEnter={requireAuth}/>
                <Route path="feed-sources" component={FeedSources} onEnter={requireAuth}/>
                <Route path="feed-source/:feedSourceId" component={FeedSource} onEnter={requireAuth}/>
            </Route>
        </Router>
    </Provider>
    , document.getElementById('app')
);